function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata876"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref3 = /*#__PURE__*/React.createElement("defs", {
  id: "defs874"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path964-7",
  d: "m 79.890558,53.300057 c -5.023407,10e-7 -9.729887,-2.526806 -12.330077,-6.789062 -2.60019,-4.262256 -2.60019,-9.651807 0,-13.914063 2.600189,-4.262255 7.306669,-6.789062 12.330077,-6.789062 v 8.089844 c -2.30083,0 -4.363847,1.171379 -5.425779,2.912109 -1.061931,1.74073 -1.061932,3.747551 0,5.488281 1.061932,1.74073 3.124949,2.91211 5.425779,2.91211 z"
}), /*#__PURE__*/React.createElement("rect", {
  ry: 0.00000359872,
  y: 35.331306,
  x: 43.841209,
  height: 7.8125,
  width: 22.815489,
  id: "rect962"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer3"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "layer2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "path4617",
  d: "m 28.101723,12.703491 c -0.933493,-3.3836219 -5.812578,-3.541156 -6.870693,0 C 15.732359,31.25107 3.9743512,36.291222 3.9743512,49.363644 c 0,11.573426 9.2549778,20.937744 20.6920248,20.937744 11.437047,0 20.692025,-9.364318 20.692025,-20.937744 0,-13.138256 -11.732143,-18.027928 -17.256678,-36.660153 z m -3.435347,50.073527 c -7.259844,0 -13.167652,-5.907807 -13.167652,-13.167654 0,-1.039307 0.841789,-1.881095 1.881093,-1.881095 1.039304,0 1.881093,0.841788 1.881093,1.881095 0,5.185937 4.219527,9.405464 9.405466,9.405464 1.039304,0 1.881094,0.841789 1.881094,1.881095 0,1.039306 -0.84179,1.881095 -1.881094,1.881095 z"
});

var SvgHumidSensor = function SvgHumidSensor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg870",
    role: "presentation",
    "aria-hidden": "true",
    viewBox: "0 0 80 80",
    focusable: "false",
    className: "MuiSvgIcon-root",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHumidSensor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/humid-sensor.74c74f98.svg";
export { ForwardRef as ReactComponent };